<template>
  <div class="wrapper">
    <div class="wrap">
      <div class="wrapBg"></div>
      <leftLayout></leftLayout>
      <headerLayout></headerLayout>
      <main>
        <div class="container">
          <section class="section01">
            <div class="object01">
              {{ $t('se002.title') }}
            </div>
          </section>
          <section class="section0201">
            <div class="object01"></div>
            <div class="object02">
              {{ $t('se002.clubName') }}
            </div>
            <div class="object03">
              {{ clubInfo.club_name }}
            </div>
            <div class="object04"></div>
            <!-- 이미지(Style) : 경로 -->
            <div
              class="object05"
              :style="{ 'background-image': 'url(' + clubInfo.club_logo + ')' }"
            ></div>
            <div class="object06"></div>
          </section>
          <section class="section0202">
            <div class="object01"></div>
            <div class="object10">
              {{ $t('se002.address') }}
            </div>
            <div class="object11">
              {{ clubInfo.club_address }}
            </div>
            <div class="object12"></div>
          </section>
          <!-- 휴장홀 노출시(Class) : closedHoleActive -->
          <section
            class="section0203"
            :class="{ closedHoleActive: clubInfo.holiday_holes }"
          >
            <div class="objectBox object01">
              <div class="objectRow">
                <div class="objectTitle">
                  <div class="object13">
                    {{ $t('se002.phone') }}
                  </div>
                </div>
                <div class="objectContent">
                  <div class="object14">
                    {{ clubInfo.club_telno }}
                  </div>
                </div>
              </div>
              <div class="objectRow">
                <div class="objectTitle">
                  <div class="object16">
                    {{ $t('se002.representative') }}
                  </div>
                </div>
                <div class="objectContent">
                  <div class="object17">
                    {{ clubInfo.club_represent_name }}
                  </div>
                </div>
              </div>
              <div class="objectRow">
                <div class="objectTitle">
                  <div class="object19">
                    {{ $t('se002.manageStatus') }}
                  </div>
                </div>
                <div class="objectContent">
                  <div class="object20">
                    {{ manageStatusName }}
                  </div>
                </div>
              </div>
              <div class="objectRow">
                <div class="objectTitle">
                  <div class="object22">
                    {{ $t('se002.aplSupportStatus') }}
                  </div>
                </div>
                <div class="objectContent">
                  <div class="object23">
                    {{ aplStatusName }}
                  </div>
                </div>
              </div>
              <div class="objectRow">
                <div class="objectTitle">
                  <div class="object25">
                    {{ $t('se002.clubStatus') }}
                  </div>
                </div>
                <div class="objectContent">
                  <div class="object26">
                    {{ activeStatusName }}
                  </div>
                </div>
              </div>
              <div class="objectRow">
                <div class="objectTitle">
                  <div class="object28">
                    {{ $t('se002.region') }}
                  </div>
                </div>
                <div class="objectContent">
                  <div class="object29">
                    {{
                      getRegion(
                        setRegionCode(clubInfo.ccode, clubInfo.region_code)
                      )
                    }}
                  </div>
                </div>
              </div>
              <div class="objectRow">
                <div class="objectTitle">
                  <div class="object31">
                    {{ $t('se002.pinSize') }}
                  </div>
                </div>
                <div class="objectContent">
                  <div class="object32">
                    {{ confirmPinSize(clubInfo.pin_size) }}
                  </div>
                </div>
              </div>
              <div class="objectRow">
                <div class="objectTitle">
                  <div class="object34">
                    {{ $t('se002.closedDay') }}
                  </div>
                </div>
                <div class="objectContent">
                  <div class="object35">
                    {{
                      makeOffDayTxt(
                        this.clubInfo.holiday_start,
                        this.clubInfo.holiday_end,
                        this.clubInfo.holiday_week_ju,
                        this.clubInfo.holiday_week
                      )
                    }}
                  </div>
                </div>
              </div>
              <div class="objectRow">
                <div class="objectTitle">
                  <div class="object37">
                    {{ $t('se002.closedToday') }}
                  </div>
                </div>
                <div class="objectContent">
                  <div class="object38">
                    {{ isTodayOff(clubInfo) ? 'O' : 'X' }}
                  </div>
                </div>
              </div>
              <div class="objectRow closedHole">
                <div class="objectTitle">
                  <div class="closedHoleTitle">
                    {{ $t('se002.closedHoles') }}
                  </div>
                </div>
                <div class="objectContent">
                  <div class="closedHoleContent">
                    <ul class="list">
                      <li v-for="(holes, course) in holidayHoles" :key="course">
                        {{ course }} -
                        {{
                          holes
                            .map(h => $t('se002.holeNumber', { n: h }))
                            .join(', ')
                        }}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="objectRow">
                <div class="objectTitle">
                  <div class="object40">
                    {{ $t('se002.pinChangeMethod') }}
                  </div>
                </div>
                <div class="objectContent">
                  <div class="object41">
                    {{ clubInfo.pin_change }}
                  </div>
                </div>
              </div>
              <div class="objectRow last">
                <div class="objectTitle">
                  <div class="object43">
                    {{ $t('se002.remarks') }}
                  </div>
                </div>
                <div class="objectContent">
                  <div class="object44">
                    {{ clubInfo.uniqueness }}
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section class="section03">
            <div
              class="object01"
              v-if="userInfo.userRole !== 'ClubManager'"
              @click="moveMenu('/SE001')"
            >
              {{ $t('common.list') }}
            </div>
            <div class="object02">
              {{ $t('se002.lastUpdated') }}
              {{
                clubInfo.updt_dt === null ? clubInfo.isrt_dt : clubInfo.updt_dt
              }}
              ({{
                clubInfo.updt_name === null
                  ? clubInfo.isrt_name
                  : clubInfo.updt_name
              }}
              ID
              {{
                clubInfo.updt_id === null ? clubInfo.isrt_id : clubInfo.updt_id
              }})
            </div>
            <div
              class="object03"
              @click="moveMenu('/SE004?ccode=' + currentClubCode)"
            >
              {{ $t('se002.editButton') }}
            </div>
          </section>
        </div>
      </main>
      <footerLayout></footerLayout>
    </div>
  </div>
</template>

<script>
/* Layout */
import LeftLayout from '../layout/Left.vue'
import HeaderLayout from '../layout/Header.vue'
import FooterLayout from '../layout/Footer.vue'

import { commonService, settingService, userService } from '../../router'

export default {
  name: 'SE002',
  data () {
    return {
      clubInfo: {
        club_name: '',
        club_logo: '',
        club_address: '',
        club_telno: '',
        club_represent_name: '',
        active_status: '',
        manage_status: '',
        apl_status: '',
        isrt_id: '',
        isrt_name: '',
        isrt_dt: '',
        updt_id: '',
        updt_name: '',
        updt_dt: '',
        holidays: '',
        holiday_start: '',
        holiday_end: '',
        holiday_week_ju: '',
        holiday_week: '',
        holiday_holes: ''
      },
      activeStatusName: this.$t('se002.inactive'),
      selectActiveStatus: 'inactive',
      activeStatusList: [
        { name: this.$t('se002.active'), code: 'active' },
        { name: this.$t('se002.inactive'), code: 'inactive' }
      ],
      manageStatusName: this.$t('se002.planned'),
      selectManageStatus: 'inactive',
      manageStatusList: [
        { name: this.$t('se002.operating'), code: 'active' },
        { name: this.$t('se002.planned'), code: 'inactive' }
      ],
      aplStatusName: this.$t('se002.preparing'),
      selectAplStatus: 'ready',
      aplStatusList: [
        { name: this.$t('se002.inService'), code: 'service' },
        { name: this.$t('se002.underMaintenance'), code: 'check' },
        { name: this.$t('se002.preparing'), code: 'ready' }
      ],
      clubRegion: [
        { name: this.$t('se002.regionGyeonggiIncheon'), code: 1 },
        { name: this.$t('se002.regionChungbuk'), code: 10 },
        { name: this.$t('se002.regionChungnam'), code: 11 },
        { name: this.$t('se002.regionJeolla'), code: 20 },
        { name: this.$t('se002.regionGyeongbuk'), code: 30 },
        { name: this.$t('se002.regionGyeongnam'), code: 31 },
        { name: this.$t('se002.regionGangwon'), code: 40 },
        { name: this.$t('se002.regionJeju'), code: 50 }
      ],
      pinSize: '27',
      selectPinSize: '2',
      pinSizeArr: [
        { size: '13', code: '0' },
        { size: '20', code: '1' },
        { size: '27', code: '2' }
      ],
      courseList: []
    }
  },
  created: function () {
    this.currentClubCode = this.$route.query.ccode
    userService.getAll().then(response => {
      this.userInfo = response.data
      if (
        this.userInfo.userRole === 'ClubManager' &&
        this.userInfo.ccode !== this.$route.query.ccode
      ) {
        this.moveMenu('/')
      } else {
        this.setData()
      }
    })
    commonService
      .getCourseListByCcode(this.currentClubCode)
      .then(response => {
        this.courseList = response.data.courseList.sort((a, b) =>
          a.startIdx < b.startIdx ? -1 : a.startIdx > b.startIdx ? 1 : 0
        )
      })
      .catch(error => {
        console.log('getCourseListByCcode.err.===>', error)
      })
  },
  mounted: function () {},
  components: {
    LeftLayout,
    HeaderLayout,
    FooterLayout
  },
  methods: {
    setData: function () {
      settingService
        .getClubInfoDetail(this.currentClubCode)
        .then(response => {
          this.clubInfo = response.data.clubInfo
        })
        .catch(error => {
          console.log('getClubInfoList.err.===>', error)
        })
    },
    getRegion: function (regionCode) {
      if (!regionCode) return ''
      return this.clubRegion.find(it => it.code === regionCode).name
    },
    getManageStatusName (status) {
      if (!status) return ''
      const target = this.manageStatusList.find(it => it.code === status)
      return target ? target.name : ''
    },
    getAplStatusName (status) {
      if (!status) return ''
      const target = this.aplStatusList.find(it => it.code === status)
      return target ? target.name : ''
    },
    getActiveStatusName (status) {
      if (!status) return ''
      const target = this.activeStatusList.find(it => it.code === status)
      return target ? target.name : ''
    },
    getPinSize (pinSize) {
      if (!pinSize) return ''
      const target = this.pinSizeArr.find(it => it.code === pinSize)
      return target ? target.size : ''
    },
    getCourseData: function (hlidx) {
      return this.courseList.find(
        it => it.startIdx <= hlidx && it.endIdx > hlidx
      )
    }
  },
  computed: {
    holidayHoles () {
      if (!this.clubInfo.holiday_holes) return
      return this.clubInfo.holiday_holes.split(',').reduce((acc, curr) => {
        const course = this.getCourseData(curr - 1)
        if (!course) return
        const courseName = course.name
        if (acc[courseName]) {
          acc[courseName].push(curr - course.startIdx)
        } else {
          acc[courseName] = [curr - course.startIdx]
        }
        return acc
      }, {})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/setting/SE002.vue